<template>
  <div class="video-wrapper">
    <div
      class="video"
      :class="{ 'is-playing': isVideoPlaying }"
      data-cy="youtube-video"
    >
      <button
        v-if="hasAcceptedCookies"
        class="video-play-button button-unstyled"
        data-cy="video-play-button"
        @click="playVideo"
      >
        <Icon
          name="play"
          icon="play"
          size="medium"
        />
      </button>
      <Spinner />
      <img
        :src="placeholderImage"
        class="video-placeholder-image"
        :alt="description"
        loading="lazy"
        data-cy="video-placeholder-image"
      >
      <div :id="videoContainerId" />

      <div
        v-if="hasCookieBotLoaded && !hasAcceptedCookies"
        class="video-fallback-message"
      >
        <p>
          Please
          <button
            class="button-unstyled"
            @click="acceptCookies"
          >
            accept marketing-cookies
          </button> to watch this video.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import YouTubePlayer from 'youtube-player';
import Icon from '@/components/shared/IconBase.vue';
import Spinner from '@/components/shared/Spinner.vue';
import { generate5DigitId } from '@/utils/id';

const props = defineProps({
  placeholderImage: { type: String, required: true },
  videoId: { type: String, required: true },
  description: { type: String, default: null },
});

const videoContainerId = computed(() => `videoPlayer_${generate5DigitId()}`);
const videoOptions = ref({
  videoId: props.videoId,
  playerVars: {
    autoplay: 1,
    color: 'white',
  },
});
const isVideoPlaying = ref(false);
const hasCookieBotLoaded = ref(false);
const hasAcceptedCookies = ref(false);

onMounted(() => {
  if (window.Cookiebot) {
    hasCookieBotLoaded.value = true;
    updateCookieStatus();
  }

  window.addEventListener('CookiebotOnConsentReady', updateCookieStatus, false);
  window.addEventListener('CookiebotOnAccept', updateCookieStatus, false);
});

function playVideo() {
  const player = new YouTubePlayer(videoContainerId.value, videoOptions.value);
  player.playVideo();
  isVideoPlaying.value = true;
}

function updateCookieStatus() {
  if (window.Cookiebot) {
    hasAcceptedCookies.value = (window.Cookiebot?.consent?.marketing === true);
  }
}

function acceptCookies() {
  if (window.Cookiebot) {
    window.Cookiebot.renew();
  }
}
</script>
